import styled, { keyframes } from "styled-components";
import Overlay from "../../../Componentes/Overlay";
import Modal from "../../../Componentes/Utils/Modal";
import { useState } from "react";
import { TbLoader2 } from "react-icons/tb";

import useApi from "../../../hooks/useApi";
const Title = styled.h2`
    font-size: 20px;
    font-weight: 600;
    margin: 5px 0 5px 10px;
    color: #000;
`
const Subtitle = styled.h3`
    font-size: 13px;
    font-weight: 500;
    margin: 5px 10px 0 10px;
    color: #333;
`
const BotoesContainer = styled.div`
    width: 100%;
    display: flex;
    height: 40px;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
`
const Botao = styled.button`
    width: 48%;
    height: 35px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    color: white;
    background-color: ${props => props.cancel ? '#6c757d' : '#dc3545'};
    &:hover {
        opacity: 0.8;
    }
`
const rotate = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`
const IconeLoading = styled(TbLoader2)`
    animation: ${rotate} 1s linear infinite;
    font-size: 24px;
`

const ModalDeleteCategoria = ({ categoria, updateCategorias, closeModal }) => {
    const api = useApi();


    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {

        setLoading(true);

        try {

            await api.post("/Painel/API/Desvios/DeleteCategoriaRisco/", {
                id_categoria: categoria.uuid
            })

            await updateCategorias();
            closeModal();

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }

    }

    return (
        <>
            <Overlay state={true} >
                <Modal size="sm" close={closeModal} >
                    <Title>Excluir Categoria</Title>
                    <Subtitle>Tem certeza que deseja excluir a categoria "{categoria.nome}"?</Subtitle>
                    <BotoesContainer>
                        <Botao cancel onClick={closeModal} >CANCELAR</Botao>
                        <Botao onClick={handleDelete} >{loading ? <IconeLoading /> : "EXCLUIR"}</Botao>
                    </BotoesContainer>
                </Modal>
            </Overlay>
        </>
    )
}

export default ModalDeleteCategoria;